import type WebModel from '../models/WebModel'

const USERSYNC_INIT_INTERVAL = 100

export namespace Usersync {
  // setInterval in the browser returns a number, but here we get a Node Timer instance
  let usersyncTimer

  export const init = (model: WebModel) => {
    if (window.$mediavine.web.usersyncInit) {
      clearInterval(usersyncTimer)
      window.$mediavine.web.usersyncInit(model)
    }
    if (!usersyncTimer && !window.$mediavine.web.usersyncInit) {
      usersyncTimer = setInterval(() => init(model), USERSYNC_INIT_INTERVAL)
    }
  }
}
